<template>
  <div class="roleManagement-container">
    <zr-table
      ref="pageTable"
      class="table-box"
      :loading-show="listLoading"
      :data="list"
      :columns="columns"
      enabled-index
      stripe
    >
      <template v-slot:enabled="{ row }">
        <el-switch
          :value="row.enabled"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </template>
      <template v-slot:operate="{ row }">
        <el-button type="text" @click="handleEdit(row)">人员 </el-button>
      </template>
    </zr-table>
    <el-input
      v-model.trim="xueli"
      type="textarea"
      placeholder="输入学历"
      clearable
    >
    </el-input>
    <el-button style="margin-left: 10px" @click="jisuanXueli">计算 </el-button>
    没递归出来，多点直到数据不变化为止
    <el-input
      v-model.trim="jieguo"
      type="text"
      placeholder="学历情况计算结果"
      clearable
    >
    </el-input>
    <user-data-dialog
      v-if="dialogVisible"
      :dialog-visible.sync="dialogVisible"
      :dialog-data="dialogData"
      @dialogVisibleChange="dialogVisibleChange"
    ></user-data-dialog>
  </div>
</template>

<script>
import { searchRoles } from "@/api/framework/basicData/role";
import UserDataDialog from "./userDataDialog";
export default {
  name: "RoleManagement",
  components: {
    UserDataDialog,
  },
  data() {
    return {
      list: [],
      xueli: "",
      jieguo: "",
      listLoading: true,
      queryForm: {
        roleName: "",
      },
      columns: [
        { code: "name", name: "角色名称" },
        { code: "desp", name: "描述" },
        {
          code: "operate",
          name: "操作",
          fixed: "right",
          needDrawCell: true,
        },
      ],
      total: 0,
      filterProps: {},
      researchRoleType: {},
      dialogData: {},
      addInitData: {
        id: null,
        roleName: "",
        name: "",
        roleCode: "",
        roleType: "",
        useType: "publicRole",
        deptCode: "",
        orgCode: "四川中锐信息技术有限公司",
        sort: 1,
        isUseable: true,
        desp: "",
      },
      dialogVisible: false,
    };
  },
  async created() {
    await this.fetchListData();
  },
  methods: {
    // 递归删除无效的逗号
    clearString(data) {
      for (let i = 0; i < data.length; i++) {
        if (
          (data.substring(i, i + 1) == "," ||
            data.substring(i, i + 1) == "，") &&
          isNaN(data.substring(i - 1, i)) &&
          isNaN(data.substring(i + 1, i + 2))
        ) {
          // 第i+1个字符等于逗号，且左右两个字符都不是数字则删除这个逗号
          data = data.slice(0, i) + data.slice(i + 1, data.length);
          this.clearString(data);
          break;
        }
      }
      return data;
    },
    // 统计数据站过来进行处理
    jisuanXueli() {
      this.xueli = this.clearString(this.xueli);
      console.log(this.xueli);
      let list = this.xueli.split(",");
      let resultList = [];
      for (let i = 0; i < list.length; i += 2) {
        let result = {};
        result.xueli = list[i];
        result.num = parseInt(list[i + 1]);
        resultList.push(result);
      }
      console.log(resultList);
      let sum = 0;
      let boshi = 0;
      let shuoshi = 0;
      let xueshi = 0;
      let dazhuan = 0;
      for (let i in resultList) {
        sum += resultList[i].num;
        console.log(resultList[i].xueli.search("博士"));
        if (resultList[i].xueli.search("博士") !== -1) {
          boshi += resultList[i].num;
        } else if (
          resultList[i].xueli.search("硕士") !== -1 ||
          resultList[i].xueli.search("研究生") !== -1
        ) {
          shuoshi += resultList[i].num;
        } else if (
          resultList[i].xueli.search("学士") !== -1 ||
          resultList[i].xueli.search("本") !== -1
        ) {
          xueshi += resultList[i].num;
        } else if (
          resultList[i].xueli.search("大专") !== -1 ||
          resultList[i].xueli.search("专科") !== -1
        ) {
          dazhuan += resultList[i].num;
        }
      }
      let string =
        "总数：" +
        sum +
        "\n博士：" +
        boshi +
        "\n硕士：" +
        shuoshi +
        "\n学士：" +
        xueshi +
        "\n大专：" +
        dazhuan;
      this.jieguo = string;
    },
    handleEdit(row) {
      this.dialogData = { action: "edit", data: row };
      this.dialogVisible = true;
    },
    handleView(row) {
      this.dialogData = { action: "view", data: row };
      this.dialogVisible = true;
    },
    queryData() {
      if (this.queryForm.roleName) {
        this.filterProps.name = this.queryForm.roleName;
      } else {
        delete this.filterProps.name;
      }
    },
    async fetchListData() {
      const res = await searchRoles({ roleType: "ywRole" });
      if (res.success) {
        let data = res.data;
        this.list = data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 300);
    },
    dialogVisibleChange(val) {
      this.dialogVisible = val;
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";

.table-box {
  height: calc(#{$table-box-height} + 48px);
}

.el-card {
  margin-bottom: 0;
}

.el-card__header {
  padding: 8px 20px;
}

.el-card__body {
  padding: 0 10px 0 10px;
}

.type-icon {
  span {
    color: $base-color-blue;
  }
}
</style>
